/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Close, Save } from "@mui/icons-material";
import {
  Card,
  CardContent,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Form, FormikProvider, useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";

import PageContainer from "@jumbo/components/PageContainer";
import LoadingButton from "@jumbo/components/JumboLoadingButton";
import moment from "moment";
import { BILL_LIST } from "app/routes/constant";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import Loader from "@jumbo/components/Loader";
import { getVendorList } from "app/redux/slice/vendorSlice";
import { getFabricList } from "app/redux/slice/fabricSlice";
import { getProductList } from "app/redux/slice/productSlice";
import { getVariantList } from "app/redux/slice/variantSlice";
import { getByIdBill, updateBill } from "app/redux/slice/billSlice";

const useStyles = makeStyles({
  headingTitle: {
    minWidth: "80px",
  },
  table: {
    minWidth: 650,
    boxShadow: "none",
    "& .MuiTableCell-root": {
      boxShadow: "none",
      borderLeft: "1px solid",
      borderBottom: "1px solid",
    },
  },
  inputStyle: {
    "& .MuiInputLabel-formControl.Mui-disabled": {
      color: "#37373C !important",
      textFillColor: "#37373C !important",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#37373C !important",
      textFillColor: "#37373C !important",
    },
  },
  particular: {
    minWidth: "300px",
  },
  variants: {
    minWidth: "300px",
  },
  amount: {
    minWidth: "100px",
    verticalAlign: "top",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "end",
    margin: "6px 0px",
  },
  margin: {
    "& > :first-child": {
      marginTop: "10px",
    },
    marginBottom: "10px",
  },
  alignTop: {
    verticalAlign: "top",
  },
  loadingButtonContainer: {
    display: "flex",
    justifyContent: "end",
    marginTop: "20px",
  },
  imageUploadContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    padding: "5px",
    border: "2px dashed #ccc",
    borderRadius: "8px",
    minHeight: "120px",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#1976d2",
    },
  },
  imagePreview: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  hiddenInput: {
    display: "none",
  },
});

const DebitNote = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const fabricData = useSelector((state) => state?.fabric);
  const productData = useSelector((state) => state?.product);
  const variantData = useSelector((state) => state?.variant);
  const mobileView = useMediaQuery("(max-width:575px)");
  const [loading, setLoading] = useState(false);
  const [isLocal, setIsLocal] = useState(true);

  const validationSchema = yup.object({
    date: yup.string().required("Please enter a due date."),
  });

  const removeBlankStringKeys = (obj) =>
    Array.isArray(obj)
      ? obj.map(removeBlankStringKeys)
      : obj && typeof obj === "object"
      ? Object.fromEntries(
          Object.entries(obj)
            .filter(([_, v]) => v !== "")
            .map(([k, v]) => [k, removeBlankStringKeys(v)])
        )
      : obj;

  const formik = useFormik({
    initialValues: {
      date: moment(new Date()).format("YYYY-MM-DD"),
      remark: "",
      items: [
        {
          fabricId: "",
          variantId: "",
          productId: "",
          quantity: "",
          rate: "",
          amount: "",
          fold: "",
          foldMeter: "",
          wastage: "",
          maxQuantity: "",
        },
      ],
    },
    validationSchema: validationSchema,
    context: { isLocal },
    validateOnChange: false,
    onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
      const newItems = removeBlankStringKeys(values?.items);
      const newValues = removeBlankStringKeys(values);
      const finalValues = { ...newValues, items: newItems };
      console.log(finalValues);
      return;
      try {
        const response = await dispatch(
          updateBill({ id: id, data: finalValues })
        ).unwrap();

        if (response?.status === 200) {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "success",
          });
          navigate(BILL_LIST);
          resetForm();
        } else {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "error",
          });
        }
      } catch (error) {
        enqueueSnackbar(error?.data?.responseMessage, {
          variant: "error",
        });
      }
      setSubmitting(false);
    },
  });

  const { values, setFieldValue, errors } = formik;
  const { isSubmitting } = formik;

  const handleChange = (index, field, value) => {
    let updatedFields = [...values.items];

    if (updatedFields[index].maxQuantity < value) {
      updatedFields[index][field] = updatedFields[index].maxQuantity;
    } else {
      updatedFields[index][field] = value;
    }

    // Calculate amount based on createFor type
    if (field === "quantity" || field === "rate" || field === "foldMeter") {
      const rate = Number(updatedFields[index].rate) || 0;
      let quantity = Number(updatedFields[index].quantity) || 0;
      updatedFields[index].amount = quantity * rate;
    }

    setFieldValue("items", updatedFields);

    if (field === "productId") {
      setFieldValue(`items[${index}].variantId`, "");
    }
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(getByIdBill(id))
        .unwrap()
        .then((response) => {
          if (response?.status === 200) {
            const billDetail = response?.data?.data;

            if (billDetail?.vendorId?.state === "Gujarat") {
              setIsLocal(true);
            } else {
              setIsLocal(false);
            }
            setFieldValue("createFor", billDetail?.createFor);

            let productArr = [];
            for (let i = 0; i < billDetail?.items.length; i++) {
              const element = billDetail?.items[i];
              productArr?.push({
                fabricId: element?.fabricId,
                variantId: element?.variantId?._id,
                productId: element?.productId?._id,
                quantity: 0,
                maxQuantity: element?.quantity,
                rate: element?.rate,
                amount: element?.amount,
                fold: element?.fold ?? "",
                foldMeter: element?.foldMeter ?? "",
                wastage: element?.wastage ?? "",
              });
            }
            setFieldValue("items", productArr);

            setLoading(false);
          } else {
            enqueueSnackbar(response.data?.responseMessage, {
              variant: "error",
            });
            setLoading(false);
          }
        });
    }
  }, [id]);

  useEffect(() => {
    dispatch(getVendorList({ sort: 1, field: "name" }));
    dispatch(getFabricList({ sort: 1, field: "name" }));
    dispatch(getProductList({ sort: 1, field: "name" }));
    dispatch(getVariantList());
  }, []);

  const { handleSubmit } = formik;

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <PageContainer heading={"Debit Note"}>
          <Card>
            <CardContent>
              <FormikProvider value={formik}>
                <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                  <Grid container border={1}>
                    <Grid item sm={6} xs={12} p={1}>
                      <TextField
                        label={"Due Date*"}
                        name="date"
                        fullWidth
                        size="small"
                        type="date"
                        onChange={(evt) =>
                          setFieldValue("date", evt.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                        value={values?.date}
                        error={errors?.date}
                        className={classes?.inputStyle}
                        helperText={errors?.date}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    borderRight={1}
                    sx={{
                      mt: { xs: 3, md: 0 },
                    }}
                    className="mobile-view-table"
                  >
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 650 }}
                        size="small"
                        aria-label="a dense table"
                        className={`${classes?.table}`}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr. No.</TableCell>
                            {values?.createFor === "Fabric" ||
                            values.createFor === "Dyer" ? (
                              <TableCell style={{ minWidth: "200px" }}>
                                Fabric
                              </TableCell>
                            ) : (
                              ""
                            )}
                            {values?.createFor === "Modeling" ||
                            values?.createFor === "ReadyMade" ||
                            values?.createFor === "Stitch" ? (
                              <TableCell style={{ minWidth: "200px" }}>
                                Product
                              </TableCell>
                            ) : (
                              ""
                            )}
                            {values?.createFor === "Modeling" ||
                            values?.createFor === "ReadyMade" ||
                            values?.createFor === "Stitch" ? (
                              <TableCell style={{ minWidth: "200px" }}>
                                Variant
                              </TableCell>
                            ) : (
                              ""
                            )}
                            <TableCell style={{ minWidth: "120px" }}>
                              Quantity{" "}
                              {values?.createFor === "Fabric" ||
                              values.createFor === "Dyer"
                                ? "(in meter)"
                                : ""}
                            </TableCell>
                            {values?.createFor === "Fabric" && (
                              <>
                                <TableCell style={{ minWidth: "120px" }}>
                                  Fold
                                </TableCell>
                                <TableCell style={{ minWidth: "120px" }}>
                                  Fold Meter
                                </TableCell>
                              </>
                            )}
                            {values.createFor === "Dyer" ? (
                              <TableCell style={{ minWidth: "200px" }}>
                                Wastage
                              </TableCell>
                            ) : (
                              ""
                            )}
                            <TableCell style={{ minWidth: "170px" }}>
                              Rate
                            </TableCell>
                            <TableCell
                              style={{ minWidth: "160px", textAlign: "end" }}
                            >
                              Amount
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values?.items?.length &&
                            fabricData?.list?.length &&
                            values?.items?.map((item, index) => {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    className={classes?.alignTop}
                                    sx={{ width: "10px", paddingTop: "20px" }}
                                  >
                                    {index + 1}
                                  </TableCell>
                                  {values?.createFor === "Fabric" ||
                                  values.createFor === "Dyer" ? (
                                    <TableCell
                                      className={`${classes?.alignTop}`}
                                    >
                                      <JumboAutoComplete
                                        disabled={
                                          values.createFor !== "Dyer" || id
                                        }
                                        sx={{ marginTop: "7px" }}
                                        options={fabricData?.list ?? []}
                                        label="Fabric*"
                                        size="small"
                                        getOptionLabel={(option) =>
                                          option?.name
                                        }
                                        className={classes?.inputStyle}
                                        name={`items[${index}].fabricId`}
                                        value={fabricData?.list?.find(
                                          (data) => data?._id === item?.fabricId
                                        )}
                                        onChange={(evt, value) => {
                                          handleChange(
                                            index,
                                            "fabricId",
                                            value?._id
                                          );
                                        }}
                                        helperText={
                                          formik?.errors?.items?.length &&
                                          formik?.errors?.items[index]?.fabricId
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option?._id === value?._id
                                        }
                                      />
                                    </TableCell>
                                  ) : (
                                    ""
                                  )}
                                  {values?.createFor === "Modeling" ||
                                  values?.createFor === "ReadyMade" ||
                                  values?.createFor === "Stitch" ? (
                                    <TableCell
                                      className={`${classes?.alignTop}`}
                                    >
                                      <JumboAutoComplete
                                        disabled
                                        sx={{ marginTop: "7px" }}
                                        options={productData?.list ?? []}
                                        label="Product*"
                                        size="small"
                                        getOptionLabel={(option) =>
                                          option?.name
                                        }
                                        name={`items[${index}].productId`}
                                        value={productData?.list?.find(
                                          (data) =>
                                            data?._id === item?.productId
                                        )}
                                        className={classes?.inputStyle}
                                        onChange={(evt, value) => {
                                          handleChange(
                                            index,
                                            "productId",
                                            value?._id
                                          );
                                        }}
                                        helperText={
                                          formik?.errors?.items?.length &&
                                          formik?.errors?.items[index]
                                            ?.productId
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option?._id === value?._id
                                        }
                                      />
                                    </TableCell>
                                  ) : (
                                    ""
                                  )}
                                  {values?.createFor === "Modeling" ||
                                  values?.createFor === "ReadyMade" ||
                                  values?.createFor === "Stitch" ? (
                                    <TableCell
                                      className={`${classes?.alignTop}`}
                                    >
                                      <JumboAutoComplete
                                        sx={{ marginTop: "7px" }}
                                        disabled
                                        options={
                                          variantData?.list?.filter(
                                            (data) =>
                                              data?.productId ===
                                              item?.productId
                                          ) ?? []
                                        }
                                        label={
                                          variantData?.list?.filter(
                                            (data) =>
                                              data?.productId ===
                                              item?.productId
                                          )?.length > 0
                                            ? "Variant*"
                                            : "Variant"
                                        }
                                        className={classes?.inputStyle}
                                        size="small"
                                        getOptionLabel={(option) =>
                                          option?.name
                                        }
                                        name={`items[${index}].variantId`}
                                        value={
                                          item?.variantId
                                            ? variantData?.list?.find(
                                                (data) =>
                                                  data?._id === item?.variantId
                                              )
                                            : null
                                        }
                                        // Debug: log the variant value
                                        onFocus={() => {
                                          console.log(
                                            "Variant field focused, item.variantId:",
                                            item?.variantId
                                          );
                                        }}
                                        onChange={(evt, value) => {
                                          handleChange(
                                            index,
                                            "variantId",
                                            value?._id
                                          );
                                        }}
                                        helperText={
                                          formik?.errors?.items?.length &&
                                          formik?.errors?.items[index]
                                            ?.variantId
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option?._id === value?._id
                                        }
                                      />
                                    </TableCell>
                                  ) : (
                                    ""
                                  )}
                                  <TableCell className={`${classes?.alignTop}`}>
                                    <TextField
                                      sx={{ marginTop: "7px" }}
                                      placeholder="Qty"
                                      label="Qty*"
                                      name={`items[${index}].quantity`}
                                      fullWidth
                                      value={item?.quantity}
                                      size="small"
                                      type="number"
                                      onChange={(evt) =>
                                        handleChange(
                                          index,
                                          "quantity",
                                          +evt.target.value
                                        )
                                      }
                                      className={classes?.inputStyle}
                                      error={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.quantity
                                      }
                                      helperText={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.quantity
                                      }
                                    />
                                  </TableCell>
                                  {values?.createFor === "Fabric" && (
                                    <>
                                      <TableCell
                                        className={`${classes?.alignTop}`}
                                      >
                                        <TextField
                                          disabled
                                          sx={{ marginTop: "7px" }}
                                          placeholder="Fold"
                                          label="Fold"
                                          name={`items[${index}].fold`}
                                          fullWidth
                                          value={item?.fold}
                                          size="small"
                                          type="number"
                                          onChange={(evt) =>
                                            handleChange(
                                              index,
                                              "fold",
                                              +evt.target.value
                                            )
                                          }
                                          className={classes?.inputStyle}
                                          error={
                                            errors?.items?.length &&
                                            errors?.items?.[index]?.fold
                                          }
                                          helperText={
                                            errors?.items?.length &&
                                            errors?.items?.[index]?.fold
                                          }
                                        />
                                      </TableCell>
                                      <TableCell
                                        className={`${classes?.alignTop}`}
                                      >
                                        <TextField
                                          disabled
                                          sx={{ marginTop: "7px" }}
                                          placeholder="Fold Meter"
                                          label="Fold Meter*"
                                          name={`items[${index}].foldMeter`}
                                          fullWidth
                                          value={item?.foldMeter}
                                          size="small"
                                          type="number"
                                          onChange={(evt) =>
                                            handleChange(
                                              index,
                                              "foldMeter",
                                              +evt.target.value
                                            )
                                          }
                                          className={classes?.inputStyle}
                                          error={
                                            errors?.items?.length &&
                                            errors?.items?.[index]?.foldMeter
                                          }
                                          helperText={
                                            errors?.items?.length &&
                                            errors?.items?.[index]?.foldMeter
                                          }
                                        />
                                      </TableCell>
                                    </>
                                  )}
                                  {values.createFor === "Dyer" && (
                                    <TableCell
                                      className={`${classes?.alignTop}`}
                                    >
                                      <TextField
                                        disabled={id}
                                        sx={{ marginTop: "7px" }}
                                        placeholder="wastage"
                                        label="wastage*"
                                        name={`items[${index}].wastage`}
                                        fullWidth
                                        value={item?.wastage}
                                        size="small"
                                        type="number"
                                        onChange={(evt) =>
                                          handleChange(
                                            index,
                                            "wastage",
                                            +evt.target.value
                                          )
                                        }
                                        className={classes?.inputStyle}
                                        error={
                                          errors?.items?.length &&
                                          errors?.items?.[index]?.wastage
                                        }
                                        helperText={
                                          errors?.items?.length &&
                                          errors?.items?.[index]?.wastage
                                        }
                                      />
                                    </TableCell>
                                  )}

                                  <TableCell className={`${classes?.alignTop}`}>
                                    <TextField
                                      disabled
                                      sx={{ marginTop: "7px" }}
                                      placeholder="Rate"
                                      label="Rate*"
                                      name={`items[${index}].rate`}
                                      fullWidth
                                      value={item?.rate}
                                      size="small"
                                      type="number"
                                      onChange={(evt) =>
                                        handleChange(
                                          index,
                                          "rate",
                                          +evt.target.value
                                        )
                                      }
                                      className={classes?.inputStyle}
                                      error={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.rate
                                      }
                                      helperText={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.rate
                                      }
                                    />
                                  </TableCell>
                                  <TableCell
                                    sx={{ width: "10px", textAlign: "end" }}
                                  >
                                    {item?.amount || 0}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          <TableRow>
                            <TableCell
                              colSpan={
                                values?.createFor === "Fabric"
                                  ? 7
                                  : values?.createFor === "Dyer"
                                  ? 6
                                  : values?.createFor === "Modeling" ||
                                    values?.createFor === "Stitch" ||
                                    values?.createFor === "ReadyMade"
                                  ? 6
                                  : 4
                              }
                            >
                              <TextField
                                sx={{ marginTop: "7px" }}
                                placeholder="Remark"
                                label="Remark"
                                name={`remark`}
                                fullWidth
                                value={values?.remark}
                                size="small"
                                onChange={(evt) =>
                                  setFieldValue("remark", evt.target.value)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid
                      item
                      sm={12}
                      xs={12}
                      className={classes?.loadingButtonContainer}
                    >
                      {/* {!viewId ? ( */}
                      <LoadingButton
                        type="submit"
                        buttonLabel={"Save"}
                        sx={{ marginRight: "10px" }}
                        startIcon={<Save />}
                        variant="outlined"
                        fullWidth={mobileView}
                        loading={isSubmitting}
                      />
                      {/* ) : (
                        ""
                      )} */}
                      <LoadingButton
                        color={"secondary"}
                        buttonLabel={"Close"}
                        variant="outlined"
                        startIcon={<Close />}
                        onClick={() => navigate(BILL_LIST)}
                        fullWidth={mobileView}
                      />
                    </Grid>
                  </Grid>
                </Form>
              </FormikProvider>
            </CardContent>
          </Card>
        </PageContainer>
      )}
    </>
  );
};

export default DebitNote;
